var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "group_FILL0_wght400_GRAD0_opsz24",
    d: "M1,20V17.2a2.983,2.983,0,0,1,1.6-2.65,14.867,14.867,0,0,1,3.15-1.163,13.84,13.84,0,0,1,6.5,0A14.866,14.866,0,0,1,15.4,14.55,2.983,2.983,0,0,1,17,17.2V20Zm18,0V17a4.028,4.028,0,0,0-.612-2.113A5.409,5.409,0,0,0,16.65,13.15a12.485,12.485,0,0,1,4.5,1.4,4.434,4.434,0,0,1,1.375,1.112A2.138,2.138,0,0,1,23,17v3ZM9,12a3.852,3.852,0,0,1-2.825-1.175A3.852,3.852,0,0,1,5,8,3.852,3.852,0,0,1,6.175,5.175,3.852,3.852,0,0,1,9,4a3.852,3.852,0,0,1,2.825,1.175A3.852,3.852,0,0,1,13,8a3.852,3.852,0,0,1-1.175,2.825A3.852,3.852,0,0,1,9,12ZM19,8a3.852,3.852,0,0,1-1.175,2.825A3.852,3.852,0,0,1,15,12a5.033,5.033,0,0,1-.7-.062,6.181,6.181,0,0,1-.7-.138,5.938,5.938,0,0,0,1.037-1.775,5.83,5.83,0,0,0,0-4.05A5.938,5.938,0,0,0,13.6,4.2a3.058,3.058,0,0,1,.7-.163A6.654,6.654,0,0,1,15,4a3.852,3.852,0,0,1,2.825,1.175A3.852,3.852,0,0,1,19,8ZM3,18H15v-.8a.943.943,0,0,0-.137-.5.977.977,0,0,0-.363-.35,13.056,13.056,0,0,0-2.725-1.013,11.594,11.594,0,0,0-5.55,0A13.056,13.056,0,0,0,3.5,16.35a.969.969,0,0,0-.362.35A.937.937,0,0,0,3,17.2Zm6-8a2.006,2.006,0,0,0,2-2A2.006,2.006,0,0,0,9,6,2.008,2.008,0,0,0,7,8a2.008,2.008,0,0,0,2,2ZM9,18ZM9,8Z",
    transform: "translate(-1 -4)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.840728940852d6504b97e3f2cf03e5ff.svg";
export { ForwardRef as ReactComponent };